export default "__VITE_ASSET__de053c69__"